import { BreakPointCondition, UI, useBreakpointIf, HStack, VStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { Box, Button } from 'native-base';
import React from 'react';

export const OrderHistoryItemLoadingMobile = () => {
  const isBetweenTabletAndMobile = useBreakpointIf(BreakPointCondition.EqualOrUp, 'sm');

  return (
    <UI.Shadow
      testId="table-item-tablet"
      level={1}
      borderRadius="8px"
      marginY={isBetweenTabletAndMobile ? Spacing['stack.nano'] : '0'}>
      <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']}>
        <HStack alignItems="center" space={Spacing['inline.xxs']} justifyContent="space-between">
          <UI.Text isLoading />
          <UI.Text isLoading />
        </HStack>
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between">
          <UI.Text isLoading />
          <UI.Text isLoading />
        </HStack>
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
        <HStack space={Spacing['inline.xxxs']} justifyContent="space-between">
          <UI.Text isLoading />
          <UI.Text isLoading />
        </HStack>
        <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={Spacing['stack.quarck']} w="1/3">
            <UI.Text isLoading />
            <UI.Text isLoading />
          </VStack>
          <Button
            color={Color['brand.tertiary.principal']}
            variant="textLink"
            isDisabled
            rightIcon={
              <UI.Icon name="ArrowRight" size="xs" color={Color['brand.tertiary.principal']} />
            }
          />
        </HStack>
      </VStack>
    </UI.Shadow>
  );
};
